import { minBreakpoints, theme } from '@noths/polaris-client-ribbons-base';
import { mediaQuery } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

import { getIconPath } from 'src/utils/assetPaths';

const CLOSE = getIconPath('icons-24-close.svg');

const { responsiveText, spacing } = theme;

export const section = css`
  box-shadow: -4px 0 8px 0 rgba(0, 0, 0, 0.2);
  padding: 0;
  position: fixed;
  background: var(--neutral-white-base);
  top: 0;
  right: 0;
  height: 100%;
  min-width: 100%;
  display: flex;
  flex-direction: column;

  ${mediaQuery(
    { min: minBreakpoints.M },
    css`
      min-width: 0;
    `,
  )};
`;

export const header = css`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex-shrink: 0;
  padding: ${spacing.md}px;
`;

export const closeButton = css`
  width: 24px;
  height: 24px;
  padding: 0;
  display: block;
  border: none;
  background-color: transparent;
  background-image: url(${CLOSE});
  background-repeat: no-repeat;
  background-position: center;
  cursor: pointer;
`;

export const content = css`
  padding: 0 ${spacing.md}px ${spacing.xl}px;
  overflow-y: auto;
  flex-grow: 1;
  min-height: 0;

  ${mediaQuery(
    { min: minBreakpoints.M },
    css`
      padding: 0 ${spacing.xl}px ${spacing.xl}px;
    `,
  )}
`;

export const heading = css`
  ${responsiveText.HEADING.XS};
  margin: 0 0 ${spacing.md}px 0;
`;

export const footer = css`
  flex-shrink: 0;
  padding: ${spacing.md}px;
  background: var(--neutral-white-base);
  box-shadow: 0 -4px 8px 0 rgba(0, 0, 0, 0.2);
`;
